import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface ModalCloseButtonProps {
  onClick: () => void;
  className?: string;
}

export function ModalCloseButton({
  onClick,
  className,
}: ModalCloseButtonProps) {
  const { t } = useTranslation();
  return (
    <StyledCloseButton
      type="button"
      onClick={onClick}
      aria-label={t('wbs.close')}
      className={className}
    >
      <StyledCloseIcon icon={faXmark} />
    </StyledCloseButton>
  );
}

const StyledCloseButton = styled.button`
  align-items: center;
  background-color: var(--wbs-red);
  border: none;
  border-radius: 50%;
  box-shadow: var(--shadow-md-dark);
  color: var(--white);
  cursor: pointer;
  display: flex;
  height: 20px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  transition:
    background-color 0.2s,
    box-shadow 0.2s;
  width: 20px;

  &:hover:not(:disabled) {
    background-color: var(--white);
    box-shadow: var(--shadow-md-dark);
    color: var(--wbs-red);
  }

  &:active {
    background-color: var(--wbs-red);
    box-shadow: var(--shadow-md-dark);
    color: var(--white);
  }

  &:disabled {
    background-color: var(--grey-300);
    box-shadow: none;
    color: var(--grey-500);
    cursor: not-allowed;
  }
`;

const StyledCloseIcon = styled(FontAwesomeIcon)`
  font-size: 10px;
`;
